import React, { useEffect } from 'react'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import SwitchTipoProductoDTE from '../BasicSwitchTipoProducto'
import InputForm from '../InputFormV2'
import {useSelector} from 'react-redux'
import useNotaRemision from '../../../../actions/nota-remision.actions'
import {State} from '../../../../reducers'
import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'

export default function ModalProductoNR() {
  const { formProducto, errorsProducto, calculosProducto, documentosAsociados } = useSelector((state: State) => state.notaRemision)
  const {unidadesMedida} = useSelector((state: State) => state.catalogos)
  const { onChangeFormProducto, button_onClickAgregarProductoFisico, button_onClickLimpiarFormProducto, validateFormProducto, modal_OpenAgregarProdFisico} = useNotaRemision()

  useEffect(() => {
    if(!formProducto.documentoAsociado) onChangeFormProducto('documentoAsociado', documentosAsociados.find((doc) => doc.fisico === true)?.codigoGeneracion)
  }, [formProducto.documentoAsociado])
  

  const handleChangeFormProducto = (e: any) => onChangeFormProducto(e.target.name, e.target.value)
  const handleBlurFormProducto = (e: any) => validateFormProducto(e.target.name, e.target.value)
  const cerrar = () => {
    button_onClickLimpiarFormProducto()
    modal_OpenAgregarProdFisico(false)
  }

  return (
    <ModalBase Styles={{minWidth: '50%'}}>
      <div className='cf-modal-container' style={{display:"flex", rowGap:"8px"}}>
        <div>
          <h3 className='card-title l'>PRODUCTO</h3>
        </div>
        <hr className='separador' />
        <div className='label-input'>
          <InputForm
            type='select'
            options={documentosAsociados.filter((doc) => doc.fisico === true)}
            keyNameText='codigoGeneracion'
            keyNameValue='codigoGeneracion'
            onChange={(e: any) => onChangeFormProducto('documentoAsociado', e.value)}
            label='Número de documento relacionado'
            value={formProducto.documentoAsociado}
          />
        </div>
        <div className="cf-row-inputs" style={{marginTop:"1%"}}>
          {/* <InputForm required name = 'descripcion' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/> */}
          <div><InputForm required name = 'descripcion' label = 'Incluye IVA' type = 'checkbox' value = {formProducto.conIva} onChange = {(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}/></div>
        </div>
        {!formProducto.exento && (
          <p style={{color: '#019FC5'}}>
            Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra
            por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)
          </p>
        )}
        <InputForm
          className='m text-field w-input'
          maxLength={100}
          onBlur={handleBlurFormProducto}
          required
          name='descripcion'
          placeholder='Descripción'
          label='Descripción'
          type='text'
          value={formProducto.descripcion}
          error={errorsProducto.descripcion}
          onChange={handleChangeFormProducto}
        />
        <div style={{flexDirection: 'row'}}>
          <div className={`ef-form-producto-div4`}>
            <div className='label-input'>
              <InputForm
                maxLength={15}
                onBlur={handleBlurFormProducto}
                required
                name='cantidad'
                placeholder='0'
                label='Cantidad'
                type='text'
                value={formProducto.cantidad}
                error={errorsProducto.cantidad}
                onChange={handleChangeFormProducto}
              />
            </div>
            <div className='label-input'>
              <InputForm
                type='select'
                options={unidadesMedida}
                keyNameText='valor'
                keyNameValue='codigo'
                onChange={(e: any) => onChangeFormProducto('unidadMedida', e.value)}
                label='Unidad de medida'
                value={formProducto.unidadMedida}
              />
            </div>
            <div className='label-input'>
              <InputForm
                maxLength={15}
                onBlur={handleBlurFormProducto}
                required
                name='precio'
                placeholder='$0.00'
                label='Precio'
                type='text'
                value={formProducto.precio}
                error={errorsProducto.precio}
                onChange={handleChangeFormProducto}
              />
            </div>
            <div className='label-input'>
              <InputForm
                options={[{nombre: 'Porcentaje'}, {nombre: 'Monto'}]}
                keyNameText='nombre'
                keyNameValue='nombre'
                name='tipoDescuento'
                placeholder='Tipo de descuento'
                label='Tipo de desc.'
                type='select'
                value={formProducto.tipoDescuento}
                error={null}
                onChange={(e: any) => onChangeFormProducto('tipoDescuento', e.value)}
              />
            </div>
            <div className='label-input'>
              <InputForm
                maxLength={formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                leftIcon={formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                type='text'
                value={formProducto.descuento}
                name='descuento'
                onChange={(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                placeholder='0.00'
                label='Descuento'
                error={errorsProducto.descuento}
              />
            </div>
          </div>
        </div>
        <div className='cf-calculos-producto'>
          <table>
            <tbody>
              <tr className='cf-subtotal'>
                <td>Valor bruto</td>
                <td>{calculosProducto?.neto}</td>
              </tr>
              <tr className='cf-descuento'>
                <td>Descuento</td>
                <td>{calculosProducto?.descuento}</td>
              </tr>
              <tr className='cf-subtotal'>
                <td>Subtotal</td>
                <td>{calculosProducto?.subtotal}</td>
              </tr>
              <tr className='cf-subtotal'>
                <td>Impuesto al Valor Agregado 13%</td>
                <td>{calculosProducto?.iva}</td>
              </tr>
              <tr className='cf-total'>
                <td>Total</td>
                <td>{calculosProducto?.total}</td>
              </tr>
            </tbody>
          </table>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent' onClick={cerrar}>
              Cerrar
            </button>
            <button className='m button' onClick={button_onClickAgregarProductoFisico}>
              Agregar
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}
